import * as actions from "./monev.actions";
import * as types from "./monev.actionTypes";
import { ActionType, createReducer } from "typesafe-actions";
import { MonevReducerType } from "./types";
import RichTextEditor from "react-rte";

export type MonevActions = ActionType<typeof actions>;

export const initialState: MonevReducerType = {
  error: null,
  listMonev: [],
  filePeserta: '',
  isLoading: false,
  errorMessage: '',
  redirectQueue: '',
  selectedFile: null,
  selectedMonev: null,
  selectedDokumenKerjasama: null,
  editorDeskripsi: RichTextEditor.createEmptyValue(),
  editorEvaluasi: RichTextEditor.createEmptyValue(),
};

export const MonevReducer = createReducer<
MonevReducerType,
  MonevActions
>(initialState)
  // GET MONEV
  .handleAction(actions.getMonevAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: ''
  }))
  
  .handleAction(actions.getMonevAsync.success, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    isLoading: false,
    listMonev: action.payload.data.items,
  }))

  .handleAction(actions.getMonevAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // GET DOKUMEN KERJASAMA
  .handleAction(actions.getDokumenAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: ''
  }))
  
  .handleAction(actions.getDokumenAsync.success, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    isLoading: false,
    selectedDokumenKerjasama: action.payload.data,
  }))

  .handleAction(actions.getDokumenAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // UPDATE MONEV
  .handleAction(actions.updateMonevAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: ''
  }))

  .handleAction(actions.updateMonevAsync.success, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    isLoading: false,
  }))

  .handleAction(actions.updateMonevAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // DETAIL MONEV
  .handleAction(actions.getDetailAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: ''
  }))

  .handleAction(actions.getDetailAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    errorMessage: '',
    selectedMonev: action.payload.data,
    editorDeskripsi: RichTextEditor.createValueFromString(action.payload.data.DESCR_KEGIATAN, 'html'),
    editorEvaluasi: RichTextEditor.createValueFromString(action.payload.data.EVALUASI_KEGIATAN, 'html')
  }))

  .handleAction(actions.getDetailAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // CREATE MONEV
  .handleAction(actions.createMonevAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: ''
  }))

  .handleAction(actions.createMonevAsync.success, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    isLoading: false,
    redirectQueue: '/monev',
  }))

  .handleAction(actions.createMonevAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // OTHER SELECTORS
  .handleAction(types.INITIALIZE_CREATE_MONEV as any, (state, action) => ({
    ...state,
    error: null,
    filePeserta: '',
    errorMessage: '',
    fileDokumentasi: '',
    selectedMonev: action.payload.monev,
    editorEvaluasi: RichTextEditor.createEmptyValue(),
    editorDeskripsi: RichTextEditor.createEmptyValue(),
  }))

  .handleAction(types.SELECT_MONEV as any, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    redirectQueue: '',
    selectedMonev: action.payload.monev,
    editorDeskripsi: RichTextEditor.createValueFromString(action.payload.monev.DESCR_KEGIATAN, 'html'),
    editorEvaluasi: RichTextEditor.createValueFromString(action.payload.monev.EVALUASI_KEGIATAN, 'html')
  }))

  .handleAction(types.SELECT_DOKUMEN_KERJASAMA as any, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    redirectQueue: '',
    selectedDokumenKerjasama: action.payload.dokumenKerjasama,
  }))

  .handleAction(types.DELETE_FILE as any, (state, action) => ({
    ...state,
    selectedMonev: (() => {
      if (state.selectedMonev) {
        return {
          ...state.selectedMonev,
          FILE_KEGIATAN: ''
        };
      } else {
        return null;
      }
    })(),
  }))

  .handleAction(types.UPDATE_NAMA_KEGIATAN as any, (state, action) => ({
    ...state,
    selectedMonev: (() => {
      if (state.selectedMonev) {
        return {
          ...state.selectedMonev,
          NAMA_KEGIATAN: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))

  .handleAction(types.UPDATE_LOKASI as any, (state, action) => ({
    ...state,
    selectedMonev: (() => {
      if (state.selectedMonev) {
        return {
          ...state.selectedMonev,
          LOKASI_KEGIATAN: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))

  .handleAction(types.UPDATE_TANGGAL_MULAI as any, (state, action) => ({
    ...state,
    selectedMonev: (() => {
      if (state.selectedMonev) {
        return {
          ...state.selectedMonev,
          TANGGAL_MULAI_KEGIATAN: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))

  .handleAction(types.UPDATE_TANGGAL_SELESAI as any, (state, action) => ({
    ...state,
    selectedMonev: (() => {
      if (state.selectedMonev) {
        return {
          ...state.selectedMonev,
          TANGGAL_SELESAI_KEGIATAN: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))

  .handleAction(types.UPDATE_DESKRIPSI as any, (state, action) => ({
    ...state,
    editorDeskripsi: action.payload.value,
    selectedMonev: (() => {
      if (state.selectedMonev) {
        return {
          ...state.selectedMonev,
          DESCR_KEGIATAN: action.payload.value.toString('html')
        };
      } else {
        return null;
      }
    })(),
  }))

  .handleAction(types.UPDATE_EVALUASI as any, (state, action) => ({
    ...state,
    editorEvaluasi: action.payload.value,
    selectedMonev: (() => {
      if (state.selectedMonev) {
        return {
          ...state.selectedMonev,
          EVALUASI_KEGIATAN: action.payload.value.toString('html')
        };
      } else {
        return null;
      }
    })(),
  }))

  .handleAction(types.UPDATE_TAUTAN as any, (state, action) => ({
    ...state,
    selectedMonev: (() => {
      if (state.selectedMonev) {
        return {
          ...state.selectedMonev,
          LINK_DOKUMENTASI_KEGIATAN: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))

  .handleAction(types.UPDATE_PENYELENGGARA as any, (state, action) => ({
    ...state,
    selectedMonev: (() => {
      if (state.selectedMonev) {
        return {
          ...state.selectedMonev,
          PENYELENGGARA_DETAIL: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))

  .handleAction(types.UPDATE_PESERTA as any, (state, action) => ({
    ...state,
    selectedMonev: (() => {
      if (state.selectedMonev) {
        return {
          ...state.selectedMonev,
          PESERTA_DETAIL: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))

  .handleAction(types.UPDATE_DESKRIPSI_PESERTA as any, (state, action) => ({
    ...state,
    selectedMonev: (() => {
      if (state.selectedMonev) {
        return {
          ...state.selectedMonev,
          PESERTA_KEGIATAN: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))
  
  .handleAction(types.UPDATE_FILE_INPUT_PESERTA as any, (state, action) => ({
    ...state,
    filePeserta: action.payload.value
  }))

  .handleAction(types.UPDATE_DOK_ID as any, (state, action) => ({
    ...state,
    DOK_ID: action.payload.value
  }))
  
  .handleAction(types.UPDATE_FILE as any, (state, action) => ({
    ...state,
    selectedFile: action.payload.file
  }));
